<template>
 <div class='counter'>
    <h1>Welcome to the COUNTER!!</h1>
    <h4>Please interact with me</h4>
    <ul>
    <button v-on:click='clickGetCount'>GetCount</button>
    <button v-on:click='clickIncrementCounter'>IncrCounter</button>
    <li>Current Stored Count is: {{this.count}}</li>
    <li>Current incrEvent: {{this.$store.state.web3.coinbase}}</li>

  </ul>
      </div>
</template>

<script>
export default {
  name: 'counter-dapp',
  mounted () {
    console.log('dispatching getContractInstance')
    this.$store.dispatch('getContractInstance')
  },
  beforeCreate () {
    console.log('registerWeb3 Action dispatched from casino-dapp.vue')
    this.$store.dispatch('registerWeb3')
  },
  data () {
    return {
      count: null,
      incrEvent: null
    }
  },
  methods: {
    clickGetCount (event) {
      console.log('this is the current count ', this.count)
      console.log('this is the current button ', event.target.innerHTML)
      console.log(event)
      this.$store.state.contractInstance().methods.getCount().call({
        gas: 300000,
        from: this.$store.state.web3.coinbase
      }, (err, result) => {
        if (err) {
          console.log(err)
        } else {
          console.log('the count from the contract is', result)
          this.count = result
        }
      })
    },
    clickIncrementCounter (event) {
      this.$store.state.contractInstance().methods.incrementCounter().send({
        gas: 300000,
        from: this.$store.state.web3.coinbase
      }, (err, result) => {
        if (err) {
          console.log(err)
        } else {
          console.log('we incremented OK', result)
        }
      })
    }
  }
}

</script>
<style scoped>
.counter {
 margin-top: 50px;
 text-align:center;
}
</style>



// WEBPACK FOOTER //
// src/components/counter-dapp.vue